// extracted by mini-css-extract-plugin
export default {"title":"Heading_title__gFtPT","howTo":"Heading_howTo__P3ieL"};